export enum DrawHistoryType {
  Completed = 1, // 1-已成功；
  Processing = 2, // 2-已申请，处理中；
  Failed = 3, // 3-失败；
  Cancelled = 4, // 4-取消
}
export enum DrawCheckType {
  Completed = 1, // 已完成
  Failed = 3, // 失败
  Cancelled = 4, // 取消
}

export interface IDrawHistoryItem {
  readonly total: string; // 数据总数
  readonly size: string; // 每页数量
  readonly list: IDrawHistoryList[];
}

export interface IDrawHistoryList {
  readonly create_time: string; // 申请提现时间
  readonly amount: string; // 提现金额
  readonly midas_account: string; // 米大师账户
  readonly update_time: string; // 充值到账时间
  readonly draw_status: DrawHistoryType; // 提现状态：
  readonly draw_fail_detail?: string; // 失败原因
  readonly draw_id: number; // 提现记录id
  readonly draw_creator: string; // 提现账户
  readonly studio_id: string;
}

export interface IDrawCheckBody {
  readonly draw_id: number; // 	提现订单id
  readonly draw_status: DrawCheckType; // 游戏id
  readonly operator: string; // 操作人
}

export interface ISetFreezeBody {
  readonly studio_id: string;
  readonly game_id: string;
  readonly env_id: Number;
  readonly service_id: Number;
  readonly freeze_amount: number;
  readonly operator: string;
}
